import { useEffect, useState } from "react";
import { getNewSlugs, markSeen } from "@/lib/reports/seen-reports";

/**
 * Returns the set of "new since last visit" report slugs.
 * SSR-safe (returns empty set on the server / initial render).
 * Marks the provided slugs as seen ~1.2s after mount, so the badge persists
 * during this view but doesn't reappear on future visits.
 */
export function useNewReports(allSlugs: string[]): Set<string> {
  const [newSlugs, setNewSlugs] = useState<Set<string>>(() => new Set());

  // Stable key so the effect only re-runs when the actual list changes.
  const key = allSlugs.join("|");

  useEffect(() => {
    const slugs = key ? key.split("|") : [];
    setNewSlugs(getNewSlugs(slugs));
    const timer = window.setTimeout(() => markSeen(slugs), 1200);
    return () => window.clearTimeout(timer);
  }, [key]);

  return newSlugs;
}